import React, { useCallback, useEffect, useState } from 'react';
import { walletService, authService } from '../api/services';
import WalletTopUpReview from '../components/WalletTopUpReview';
import RequestTopUpReview from '../components/RequestTopUpReview';

const WalletTopUp = () => {
  const [amount, setAmount] = useState('');
  const [provider, setProvider] = useState('bank_qr');
  const [transactions, setTransactions] = useState([]);
  const [balance, setBalance] = useState(0);
  const [payment, setPayment] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [copied,setCopied]=useState('');
  const [serverOffset,setServerOffset]=useState(0),[historyPage,setHistoryPage]=useState(1),[historyLast,setHistoryLast]=useState(1);
  const paymentDone=Boolean(payment?.transaction?.id&&transactions.some((item)=>item.id===payment.transaction.id&&item.status==='paid'));
  const paymentRejected=Boolean(payment?.transaction?.id&&transactions.some((item)=>item.id===payment.transaction.id&&item.status==='rejected'));
  const methods={bank_qr:'Ngân hàng MBBank',momo:'MoMo',sepay:'Ngân hàng',vnpay:'VNPay (cũ)',listing:'Phí đăng / gia hạn',adjustment:'Điều chỉnh đối soát'};
  const statuses={pending:'Đang chờ',paid:'Đã hoàn tất',rejected:'Đã từ chối',reversed:'Đã hoàn tác',failed:'Thất bại',cancelled:'Đã hủy'};
  const copy=async(value)=>{try{await navigator.clipboard.writeText(String(value));setCopied(value);}catch{setError('Chưa sao chép được. Bạn có thể chọn và sao chép thông tin hiển thị.');}};
  useEffect(()=>{if(!copied)return;const timer=setTimeout(()=>setCopied(''),2500);return()=>clearTimeout(timer);},[copied]);

  const loadTransactions = useCallback(async (next=1) => {
    try {
      const response = await walletService.getTransactions(next);
      setBalance(Number(response?.balance || 0));
      setTransactions(Array.isArray(response?.transactions?.data) ? response.transactions.data : []);
      setHistoryPage(next);setHistoryLast(response?.transactions?.last_page||1);
      if(response.server_time)setServerOffset(Date.parse(response.server_time)-Date.now());
    } catch (requestError) {
      setError(requestError.response?.data?.message || 'Không thể tải lịch sử nạp tiền.');
    }
  },[]);

  useEffect(() => {
    loadTransactions();
  }, [loadTransactions]);
  useEffect(()=>{
    if(!payment?.transaction?.id||paymentDone||paymentRejected)return;
    const timer=setInterval(()=>{if(document.visibilityState!=='hidden')loadTransactions(historyPage);},15000);
    return()=>clearInterval(timer);
  },[payment?.transaction?.id,paymentDone,paymentRejected,historyPage,loadTransactions]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setPayment(null);
    setLoading(true);
    try {
      const response = await walletService.createTopUp({ amount, provider });
      setPayment(response);
      setAmount('');
      loadTransactions(1);
    } catch (requestError) {
      setError(requestError.response?.data?.message || 'Không thể tạo yêu cầu nạp tiền.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="container">
      <div className="form-container wallet-page">
        <h1 className="form-title">Nạp tiền</h1>
        <p className="form-subtitle">Nạp tiền vào ví để sử dụng các dịch vụ trên hệ thống.</p>
        <div className="panel wallet-balance-card">
          <span>Số dư hiện tại</span>
          <strong>{balance.toLocaleString('vi-VN')} VNĐ</strong>
        </div>
        {error && <div className="error-message">{error}</div>}

        <form onSubmit={handleSubmit} className="panel wallet-topup-form">
          <div className="form-group">
            <label className="form-label" htmlFor="topup-amount">Số tiền (VNĐ)</label>
            <input id="topup-amount" className="form-input" type="number" min="10000" max="500000000" step="1000" value={amount} disabled={loading} onChange={(event) => setAmount(event.target.value)} placeholder="Tối thiểu 10.000" required />
          </div>
          <div className="form-group">
            <label className="form-label" htmlFor="topup-provider">Phương thức thanh toán</label>
            <select id="topup-provider" className="form-select" value={provider} disabled={loading} onChange={(event) => {setProvider(event.target.value);setPayment(null);}}>
              <option value="bank_qr">Ngân hàng MBBank (QR)</option>
              <option value="momo">MoMo</option>
            </select>
          </div>
          <button className="form-button" type="submit" disabled={loading}>{loading ? 'Đang tạo yêu cầu...' : 'Tạo yêu cầu nạp tiền'}</button>
        </form>

        {paymentDone&&<section className="panel wallet-payment-result" role="status"><h2>Nạp tiền thành công</h2><p>Giao dịch {payment.transaction.transaction_code} đã hoàn tất. Số dư ví đã được cập nhật.</p></section>}
        {paymentRejected&&<p role="status">Yêu cầu nạp này đã bị từ chối. Xem lý do trong lịch sử bên dưới.</p>}
        {payment?.recipient && !paymentDone && !paymentRejected && (
          <section className="panel wallet-payment-result">
            <h2>{payment.recipient.method==='momo'?'Chuyển tiền vào ví MoMo':'Quét mã chuyển khoản MBBank'}</h2>
            <p>Số tiền: <strong>{Number(payment.transaction.amount).toLocaleString('vi-VN')} VNĐ</strong></p>
            {payment.recipient.bank_name&&<p>Ngân hàng: <strong>{payment.recipient.bank_name}</strong></p>}
            <div className="wallet-recipient"><span>{payment.recipient.method==='momo'?'Số ví MoMo':'Số tài khoản'}</span><strong>{payment.recipient.account_number}</strong><button type="button" className="btn btn-neutral btn-sm" onClick={()=>copy(payment.recipient.account_number)}>{copied===payment.recipient.account_number?'Đã sao chép':'Sao chép'}</button></div>
            <p>Chủ tài khoản: <strong>{payment.recipient.account_name}</strong></p>
            <p>Mã giao dịch: <strong>{payment.transaction.transaction_code}</strong></p>
            <button type="button" className="btn btn-neutral btn-sm" onClick={()=>copy(payment.transaction.transaction_code)}>{copied===payment.transaction.transaction_code?'Đã sao chép nội dung':'Sao chép nội dung chuyển tiền'}</button>
            {payment.payment_url&&<img src={payment.payment_url} alt="Mã QR chuyển khoản MBBank" className="wallet-qr" />}
            <p className="muted-text">{payment.recipient.method==='momo'?'Admin sẽ kiểm tra tiền thực nhận trong ví MoMo trước khi duyệt.':'Tiền được cộng tự động khi nhận giao dịch ngân hàng khớp yêu cầu.'} Nếu sau 5 phút đã chuyển tiền mà chưa được cộng ví, bấm Yêu cầu duyệt tiền trong lịch sử bên dưới.</p>
            <button type="button" className="btn btn-neutral" onClick={()=>loadTransactions(historyPage)}>Kiểm tra số dư</button>
          </section>
        )}

        <section className="section-block">
          <h2>Lịch sử giao dịch ví</h2>
          {transactions.length === 0 ? <div className="empty-state">Chưa có giao dịch nào.</div> : (
            <div className="table"><table><thead><tr><th>Mã giao dịch</th><th>Số tiền</th><th>Phương thức</th><th>Trạng thái</th></tr></thead><tbody>
              {transactions.map((transaction) => <tr key={transaction.id}><td>{transaction.transaction_code}</td><td>{Number(transaction.amount).toLocaleString('vi-VN')} VNĐ</td><td>{methods[transaction.provider]||transaction.provider}</td><td>{transaction.status==='paid'&&transaction.provider_payload?.verification==='manual_received'?'Đã duyệt thủ công':statuses[transaction.status]||transaction.status}{transaction.status==='pending'&&['bank_qr','sepay','momo'].includes(transaction.provider)&&Number(transaction.amount)>0&&<RequestTopUpReview transaction={transaction} serverOffset={serverOffset} onRequested={()=>loadTransactions(historyPage)}/>}{transaction.status==='rejected'&&transaction.review_note&&<p>Lý do: {transaction.review_note}</p>}</td></tr>)}
            </tbody></table></div>
          )}
          {historyLast>1&&<div className="action-group"><button className="btn btn-neutral" disabled={historyPage<=1} onClick={()=>loadTransactions(historyPage-1)}>Trang trước</button><span>{historyPage}/{historyLast}</span><button className="btn btn-neutral" disabled={historyPage>=historyLast} onClick={()=>loadTransactions(historyPage+1)}>Trang sau</button></div>}
        </section>
        {authService.getCurrentUser()?.role==='admin'&&<WalletTopUpReview onConfirmed={()=>loadTransactions(historyPage)}/>}
      </div>
    </main>
  );
};

export default WalletTopUp;
